// extracted by mini-css-extract-plugin
module.exports = {"rule":"DialogRule_rule__2f-S2"};